import Tooltip from "@mui/material/Tooltip";

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
  title?: string;
  placement?: any;
  IconType: any;
  onClick?: () => any;
  width?: any;
  height?: any;
  disabled?: boolean;
}

const CustomIcon = ({
  title,
  IconType,
  onClick,
  placement = "top",
  width,
  height,
  disabled = false,
  ...rest
}: IProps) => {
  return (
    <Tooltip title={disabled ? "" : title || ""} placement={placement}>
      <img
        width={width}
        height={height}
        src={IconType}
        alt={title ? title : "logo"}
        onClick={disabled ? undefined : onClick} 
        style={{
          cursor: disabled ? "not-allowed" : "pointer", 
          opacity: disabled ? 0.5 : 1, 
        }}
        {...rest}
      />
    </Tooltip>
  );
};

export default CustomIcon;
